import i18n from "i18n";
import { NoData } from "components/table/constants/NoData";

/**
 * How long ago a date was, e.g. "just now", "5 minutes ago", "2 weeks ago"
 * (texts from common.json). Without a date: the "No Data" placeholder.
 */
export const getLastLoginText = (date) => {
  if (!date) return <NoData />;

  const diffMs = Date.now() - new Date(date).getTime();
  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const ago = (key, count) => i18n.t(`common:${key}`, { count });

  if (days < 1) {
    if (hours < 1) {
      if (minutes < 1) return i18n.t("common:justNow");
      return ago("minutesAgo", minutes);
    }
    return ago("hoursAgo", hours);
  }
  if (days < 7) return ago("daysAgo", days);

  const weeks = Math.floor(days / 7);
  if (weeks < 4) return ago("weeksAgo", weeks);

  const months = Math.floor(days / 30);
  if (months < 12) return ago("monthsAgo", Math.max(months, 1));

  return ago("yearsAgo", Math.floor(days / 365));
};
